<template>
  <v-card flat outlined>
    <v-card-actions>
      <strong class="subtitle-1"><i>Packages</i></strong>
      <v-spacer></v-spacer>
      <v-alert v-if="edit_priority" type="info" class="ma-0 mr-2 pa-2" dense>The fields are disabled, click and drag rows up or down to change priority</v-alert>
      <v-spacer v-if="edit_priority"></v-spacer>
      <v-btn @click="edit_priority = false" v-if="edit_priority">Done Editing Priority Order</v-btn>
      <v-btn @click="edit_priority = true" v-else>Edit Priority</v-btn>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-text>
      <v-skeleton-loader v-if="!packageLoadingError" :loading="loadingPackages" type="table-tbody">
        <v-form ref="form">
<!--          <VueDraggable v-if="edit_priority" v-model="packages" draggable=".draggable">-->
<!--          </VueDraggable>-->
            <v-simple-table>
              <VueDraggable :disabled="!edit_priority" v-model="packages" draggable=".draggable" tag="tbody" @change="updatePriority">
                <tr v-for="(item,index) in packages" :key="index" :class="`${item.$softDelete ? 'error lighten-2' : ''} draggable`">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <v-text-field :disabled="edit_priority" v-model="item.name" label="Package Display Name" :rules="[$rules.required]"></v-text-field>
                  </td>
                  <td>
                    <v-text-field :disabled="edit_priority" v-model="item.quick_books_name" label="Quick Books Name" persistent-hint hint="If this field isn't used, it will use package display name on exports"></v-text-field>
                  </td>
                  <td>
                    <v-autocomplete :disabled="edit_priority" v-model="item.is_customer" :items="customers" item-text="primary_name.name" item-value="id" label="Customer(s)" clearable multiple></v-autocomplete>
                  </td>
                  <td>
                    <v-autocomplete :disabled="edit_priority" v-model="item.sample_category_uuid" :items="sampleCertTypes" item-text="name" item-value="uuid" label="Sample Category" clearable></v-autocomplete>
                  </td>
                  <td>
                    <v-autocomplete
                        :disabled="edit_priority" v-model="item.has_tests"
                        :items="sampleTestTypes"
                        item-text="name"
                        item-value="uuid"
                        label="Has Required Test(s)"
                        multiple
                        clearable
                    >
                    </v-autocomplete>
                  </td>
                  <td>
                    <v-autocomplete
                        :disabled="edit_priority" v-model="item.has_flags"
                        :items="sampleFlagTypes"
                        item-text="name"
                        item-value="uuid"
                        label="Has Flag(s)"
                        multiple
                        clearable
                    >
                    </v-autocomplete>
                  </td>
                  <td>
                    <v-text-field :disabled="edit_priority" v-model="item.additional_cost" label="Additional cost" prefix="$" placeholder="0.00"></v-text-field>
                  </td>
                  <td>
                    <v-btn v-if="!item.$softDelete" color="error" outlined @click="remove(item, index)" small shaped :disabled="edit_priority"><v-icon>remove</v-icon></v-btn>
                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{on}">
                        <v-btn v-on="on" outlined @click="item.$softDelete = false" small shaped :disabled="edit_priority"><v-icon>undo</v-icon></v-btn>
                      </template>
                      <span>Undo deletion</span>
                    </v-tooltip>
                  </td>
                </tr>
              </VueDraggable>
            </v-simple-table>
        </v-form>
        <v-row justify="center">
          <v-btn class="success" @click="createPackage" dark><v-icon>add</v-icon> Create Package</v-btn>
        </v-row>
      </v-skeleton-loader>
      <v-alert v-else type="error" class="error" colored-border dense dark >Failed to load config data for packages. <v-btn @click="loadExistingPackages" icon small dark><v-icon>refresh</v-icon></v-btn></v-alert>
    </v-card-text>
<!--    <v-divider></v-divider>-->
<!--    <v-card-actions>-->
<!--      <v-spacer></v-spacer>-->
<!--      <v-btn color="error" tile>Reset Changes</v-btn>-->
<!--      <v-btn color="success" tile>Save Changes</v-btn>-->
<!--    </v-card-actions>-->
  </v-card>
</template>

<script>
export default {
    name: "Packages",
    components: {
      VueDraggable: () => import('vuedraggable')
    },
    data: () => ({
      loadingPackages: true,
      packageLoadingError: false,
      edit_priority: false,
      packages: [],
    }),
    props:{
      config_ref:{
        required: true,
      },
      customers: {
        required: true,
      }
    },
    watch: {
      packages:{
        deep: true,
        handler(v){
          this.originalPackages = v
        }
      },
    },
    computed:{
      sampleFlagTypes(){
        return this.$store.$db().model('sampleFlagTypes').all();
      },
      sampleCertTypes(){
        return this.$store.$db().model('sampleCertTypeCategories').all();
      },
      sampleTestTypes(){
        return this.$store.$db().model('sampleTestTypes').all();
      },
      originalPackages: {
        get: function(){
          return this.$store.$db().model('billingPackages').query().orderBy('priority').all();
        },
        set: function(v){
          return this.$store.$db().model('billingPackages').insertOrUpdate({data: v})
        }
      }
    },
    mounted(){
      this.load()
    },
    methods: {
      async load(){
          try{
            const model = this.$store.$db().model('billingPackages');
            this.packageLoadingError = false;
            this.loadingPackages = true;
            await model.deleteAll();
            await model.load();
            this.packages = this.originalPackages;
          }catch(e){
            console.log(e, 'error')
            this.packageLoadingError = true;
          }finally{
            this.loadingPackages = false;
          }
      },
      remove(item, index){
        if(item.$isNew){
          this.packages.splice(index, 1)
          item.$delete();
        }else{
          item.$softDelete = true;
        }
      },
      async createPackage(){
        this.packages.push((await this.$store.$db().model('billingPackages').add()).billingPackages[0])
      },
      async updatePriority(){
        for(let i = 0; i < this.packages.length; i+=1){
          this.packages[i].priority = i;
          // this.$set(this.packages, i, {...this.package[i], priority: i})
        }
      },
      async reset(){
        this.packages = this.originalPackages;
      }
    }
}
</script>

<style scoped>

</style>
